const Thankyou = (props) => {
    console.log(props.rating)
    return ( 
        <div>
            <img className="thank-you-image" src="images/illustration-thank-you.svg" alt="thank you"></img>
            <button className="rating-para">You selected {props.rating} out of 5 </button>
            <h1 className="thank-you">Thank You!</h1>
            <p className="appreciation-para">We appreciate you taking the time to give a rating.If you ever need more support,don't hesitste to get in touch!</p>
        </div>
     );
}
 
export default Thankyou;